function addSparkleEffect(button) {
  // Create a container for sparkles and position it over the button
  const sparkleContainer = document.createElement('div');
  sparkleContainer.classList.add('sparkle-container');

  // Insert the sparkle container into the DOM, positioned relative to the button's parent
  button.parentElement.style.position = 'relative';
  button.parentElement.appendChild(sparkleContainer);

  // Define your two SVG stars here
  const star1 = `<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.371393 7.53667C1.71587 6.79943 3.20192 6.47297 4.28935 5.28712C5.36172 4.11964 5.68604 2.55328 6.30456 0.970703C6.45517 1.22041 6.54755 1.32959 6.59474 1.45931C6.78954 1.99332 6.97228 2.53274 7.15603 3.07108C7.75748 4.82769 8.87302 6.03192 10.5057 6.67836C10.9746 6.86429 11.4445 7.04698 11.9114 7.24048C12.056 7.29993 12.1905 7.38857 12.3381 7.54856C11.0067 8.29012 9.5066 8.61118 8.41415 9.80135C7.33576 10.9775 7.04257 12.5763 6.35778 13.9989C5.66596 12.5536 5.36875 10.9537 4.27529 9.77865C3.18284 8.60469 1.6988 8.28147 0.369385 7.53775L0.371393 7.53667Z" fill="#ffce00"/>
</svg>`;
  const star2 = `<svg width="6" height="7" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.00100671 3.52788C0.675 3.13176 1.41997 2.95636 1.9651 2.3192C2.50268 1.69192 2.66527 0.850315 2.97534 0C3.05084 0.134169 3.09715 0.192831 3.12081 0.262529C3.21846 0.549452 3.31007 0.83928 3.40218 1.12853C3.70369 2.07235 4.26292 2.71938 5.08138 3.06671C5.31644 3.16661 5.55201 3.26477 5.78607 3.36874C5.85856 3.40068 5.92601 3.44831 6 3.53427C5.33255 3.93271 4.58054 4.10521 4.03289 4.74469C3.49228 5.37662 3.3453 6.23565 3.00201 7C2.6552 6.22345 2.50621 5.36384 1.95805 4.73249C1.4104 4.10173 0.666443 3.92806 0 3.52846L0.00100671 3.52788Z" fill="#ff0000"/>
</svg>
`;

 function createSparkle() {
    const sparkle = document.createElement('div');
    sparkle.classList.add('sparkle');

    // Randomly choose between the two star SVGs
    sparkle.innerHTML = Math.random() < 0.5 ? star1 : star2;

    // Random position along the button's edge
    const side = Math.floor(Math.random() * 4);
    const x = side % 2 === 0 ? Math.random() * 100 : (side === 1 ? 100 : 0);
    const y = side % 2 === 1 ? Math.random() * 100 : (side === 2 ? 100 : 0);

    sparkle.style.left = `${x}%`;
    sparkle.style.top = `${y}%`;

    // Random direction outwards
    const angle = Math.atan2(y - 50, x - 50);
    const distance = 20 + Math.random() * 30;
    const tx = Math.cos(angle) * distance;
    const ty = Math.sin(angle) * distance;

    sparkle.style.setProperty('--tx', `${tx}px`);
    sparkle.style.setProperty('--ty', `${ty}px`);

    // Randomize animation duration
    const duration = 0.8 + Math.random() * 0.4;
    sparkle.style.animation = `fly-up ${duration}s ease-out forwards`;

    return sparkle;
  }

  function animateSparkles() {
    for (let i = 0; i < 28; i++) {
      setTimeout(() => {
        const sparkle = createSparkle();
        sparkleContainer.appendChild(sparkle);
        setTimeout(() => {
          sparkle.remove();
        }, 1000); // Increased removal time to allow full fade-out
      }, i * 15); // Slightly increased delay between sparkles
    }
  }

  button.addEventListener('click', function(event) {
    animateSparkles();
  });
}

// Usage
document.addEventListener('DOMContentLoaded', (event) => {
  const addToCartButtons = document.querySelectorAll('button[name="add"]');
  addToCartButtons.forEach(button => {
    addSparkleEffect(button);
  });
});